import Button from '@/components/Button/Button';
import cx from 'classnames';
import React from 'react';

import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined';

import styles from './BackToTop.module.scss';

export type BackToTopProps = {
  className?: string;
};

const BackToTop = ({ className }: BackToTopProps) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={cx(styles.container, className)}>
      <Button
        type="button"
        variant="outlined"
        iconRight={<KeyboardArrowUpOutlinedIcon />}
        onClick={handleClick}
        trackFunction={null}
      >
        Back to top
      </Button>
    </div>
  );
};

export default BackToTop;
